'use client'

export default function CopyrightYear() {
    return <>{new Date().getFullYear()}</>
}
